import React from 'react';

import EmailVerification from '@/modules/user/components/VerificationByEmail/EmailVerification';

const EmailVerificationPage = () => (
  <EmailVerification />
);

export default EmailVerificationPage;
